import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataTestShowDialogCellRendererModule } from '@y42/data-test/shared/cell-renderers';
import { EntryGroupCellRendererModule, FeatureListViewModule } from '@y42/feature/shared/list-view';
import { JobStatusHeaderRendererModule } from '@y42/job/ag-grid';
import { DatasourceListViewComponent } from './datasource-list-view.component';

@NgModule({
  imports: [
    CommonModule,
    JobStatusHeaderRendererModule,
    EntryGroupCellRendererModule,
    FeatureListViewModule,
    DataTestShowDialogCellRendererModule,
  ],
  declarations: [DatasourceListViewComponent],
  exports: [DatasourceListViewComponent],
})
export class DatasourceListViewModule {}
